var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmazonAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#F4B459",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4478_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6907 46.3519C34.5057 52.6269 26.3228 47.3769 21.0847 44.188C20.7606 43.987 20.2097 44.235 20.6877 44.784C22.4327 46.8999 28.1517 51.9999 35.6167 51.9999C43.0867 51.9999 47.5307 47.9239 48.0866 47.2129C48.6387 46.5079 48.2488 46.1189 47.6907 46.3519ZM51.3937 44.3069C51.0397 43.8459 49.2408 43.7599 48.1087 43.899C46.9747 44.034 45.2727 44.727 45.4207 45.143C45.4967 45.2989 45.6517 45.229 46.4307 45.159C47.2117 45.081 49.3997 44.805 49.8557 45.401C50.3137 46.001 49.1577 48.86 48.9467 49.321C48.7427 49.7821 49.0247 49.901 49.4077 49.594C49.7857 49.287 50.4697 48.492 50.9288 47.367C51.3847 46.2359 51.6627 44.6579 51.3937 44.3069Z",
    fill: "#F4B459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3537 36.391V25.883C44.3537 24.078 42.6077 20 36.3327 20C30.0587 20 26.7207 23.921 26.7207 27.453L31.9647 27.922C31.9647 27.922 33.1327 24.3921 35.8437 24.3921C38.5547 24.3921 38.3687 26.5881 38.3687 27.063V29.3461C34.8957 29.4631 26.2717 30.4551 26.2717 37.727C26.2717 45.547 36.1427 45.875 39.3797 40.821C39.5047 41.026 39.6468 41.227 39.8247 41.4151C41.0158 42.6671 42.6047 44.1591 42.6047 44.1591L46.6527 40.1591C46.6548 40.158 44.3537 38.3519 44.3537 36.391ZM32.3587 36.76C32.3587 33.401 35.9577 32.72 38.3697 32.64V35.531C38.3687 41.258 32.3587 40.391 32.3587 36.76Z",
    fill: "#484848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4478_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonAppIcon);
export default __webpack_public_path__ + "static/media/amazon-app-icon.880addd7af73c5e7cc312886ba3063a9.svg";
export { ForwardRef as ReactComponent };